import { ITeachingMaterial } from "../state";
import {
  OLD_MATERIAL_THRESHOLD,
  CATEGORY_ORDER,
  CategoryType,
} from "../constants/teaching_materials";

export const isOldMaterial = (mitsuwaId: string | undefined): boolean => {
  if (!mitsuwaId) return false;
  const num = parseInt(mitsuwaId.replace(/^[A-Za-z]+/, ""), 10);
  return !Number.isNaN(num) && num <= OLD_MATERIAL_THRESHOLD;
};

export type CategorizedMaterials<T = ITeachingMaterial> = {
  middle: T[];
  high: T[];
  core: T[];
  base: T[];
  hasMiddle: boolean;
  hasHigh: boolean;
  hasCore: boolean;
  hasBase: boolean;
  hasMultipleMaterialCategories: boolean;
};

export const getCurrentMaterials = (
  categorizedMaterials: CategorizedMaterials,
  activeTab: CategoryType,
): ITeachingMaterial[] => {
  if (!categorizedMaterials.hasMultipleMaterialCategories) {
    const key = CATEGORY_ORDER.find(k => categorizedMaterials[k].length > 0);
    return key ? categorizedMaterials[key] : [];
  }
  return categorizedMaterials[activeTab];
};

export const resolveActiveTab = (
  categorizedMaterials: CategorizedMaterials,
  preferredTab: CategoryType | null,
): CategoryType => {
  if (preferredTab !== null && categorizedMaterials[preferredTab].length > 0) {
    return preferredTab;
  }
  return (
    CATEGORY_ORDER.find(k => categorizedMaterials[k].length > 0) ?? "middle"
  );
};
